import React, { Component } from "react";
import { DeviceContext } from "context/deviceProvider";
import LetterLoading from "components/loading/letterLoading";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import "scss/screens/deviceStructure/deviceModel.scss";
import {
  Button,
  Form,
  Icon,
  Pagination,
  Select,
  Table,
  Modal,
} from "semantic-ui-react";
import Swal from "sweetalert2";

export default class DeviceModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      searchModel: null,
      devicesList: [],
      begin: 0,
      end: 10,
      pageSize: 10,
      activePage: 1,
      addDeviceModal: false,
    };
  }

  startLoading = () => this.setState({ isLoading: true });
  stopLoading = () => this.setState({ isLoading: false });

  async componentDidMount() {
    this.startLoading();
    await this.setDeviceData({ model: null });
    this.stopLoading();
  }

  setDeviceData = async (data) => {
    const { masterDeviceModels } = this.context;
    await masterDeviceModels(data);
    
    const filteredDeviceModelList = this.context.deviceModelList.filter(device => device.motor?.is_delete === 0);
  
    this.setState({
      devicesList: filteredDeviceModelList.slice(this.state.begin, this.state.end),
    });
  };

  confirmAction = (message) => {
    return new Promise((resolve) => {
      const result = window.confirm(message);
      resolve(result);
    });
  };

  deleteMotorModel = async (serial) => {
    const { deleteMotorModel } = this.context;
    const data = {
      serial: serial,
    };

    // แสดงข้อความยืนยันการลบ
    const confirmDelete = await this.confirmAction("คุณต้องการลบข้อมูลรุ่นเครื่องจักร " + serial + " ใช่หรือไม่?");
    if (!confirmDelete) {
      return; // ไม่ทำอะไรเมื่อผู้ใช้ยกเลิกการลบ
    }

    const formData = new FormData()
    formData.append("data", JSON.stringify(data));
    // statusForm = "delete";
    console.log("datadelete", data);
    
    let result = await deleteMotorModel(data);
    if (result?.result === "success") {  
      return this.alertDialog("สำเร็จ!", "ลบข้อมูลสำเร็จ", "success");   
    } else {
      return this.alertDialog("ผิดพลาด!", "ลบข้อมูลไม่สำเร็จ", "warning");
    } 
  };

  alertDialog = async (title, text, icon) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: "ok",
      confirmButtonColor: "#3085d6",
    });
  };

  onSelectImage = async (e) => {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    let result = await this.context.uploadMasterDeviceData(formData);

    if (result.status.result === "success") {  
      return this.alertDialog("สำเร็จ!", "อัปโหลดข้อมูลสำเร็จ", "success");   
    } else {
      return this.alertDialog("ผิดพลาด!", "อัปโหลดข้อมูลไม่สำเร็จ", "warning");
    } 
  };

  toggleAddDeviceModal = () => {
    this.setState((prevState) => ({
      addDeviceModal: !prevState.addDeviceModal,
    }));
  };

  createDeviceSearch = () => {
    const { deviceModelList } = this.context;
    const { searchModel } = this.state;
    // กรองข้อมูลซ้ำออกโดยใช้ filter และ map
    const uniqueDeviceModelList = deviceModelList.filter((device, index, self) =>
          index === self.findIndex((d) => d.model === device.model)
          );

    // แมปข้อมูลที่ไม่ซ้ำเป็น iotOptions
    const iotOptions = uniqueDeviceModelList.map((device, idx) => ({
    key: idx,
    value: device.model,
    text: device.model,
    }));
    return (
      <div className="search">
        <Form>
          <b>รุ่นเครื่องจักร</b>
          <Form.Group inline>
            <Form.Field
              control={Select}
              options={iotOptions}
              value={searchModel}
              placeholder="รุ่นเครื่องจักร"
              search
              onChange={(e, { value }) =>
                this.setState({ searchModel: value })
              }
            />
            <Button
              onClick={() => {
                this.setDeviceData({ model: null });
                this.setState({
                  searchModel: null,
                  level: -1,
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >
              รีเซต
            </Button>
            <Button
              color="blue"
              onClick={() => {
                this.setDeviceData({ model: searchModel });
                this.setState({
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >
              ค้นหา
            </Button>
            &emsp;
            <input
              ref="fileInput"
              onChange={this.onSelectImage}
              type="file"
              style={{ display: 'none' }}
              multiple={false}
            />
            <Button color="twitter" onClick={() => this.refs.fileInput.click()}>
              <Icon name="upload" />
              อัพโหลดรุ่นเครื่องจักร
            </Button>
          </Form.Group>
        </Form>
      </div>
    );
  };

  createDataTable = () => {
    const { devicesList } = this.state;
    return (
      <Table celled striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>ยี่ห้อเครื่องมือ</Table.HeaderCell>
            <Table.HeaderCell>รุ่นเครื่องมือ</Table.HeaderCell>
            <Table.HeaderCell>รุ่นเครื่องจักร</Table.HeaderCell>
            <Table.HeaderCell>ลบข้อมูล</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {devicesList?.map((device, idx) => (
            <Table.Row key={idx}>
              <Table.Cell>{device.motor?.brand}</Table.Cell>
              <Table.Cell>{device.motor?.series}</Table.Cell>
              <Table.Cell>{device.model}</Table.Cell>
              <Table.Cell>
                <Button  
                  className="action-btn"
                  style={{
                    fontFamily: "Kanit",
                    fontSize: "16px",
                    backgroundColor: "#ff6347",
                  }} 
                    onClick={() => this.deleteMotorModel(device.motor?.series)}>      
                  ลบข้อมูล
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  };

  paginationUpdate = (e, data) => {
    const { deviceModelList } = this.context;
    const { pageSize } = this.state;
    let beginIdx = (data.activePage - 1) * pageSize;
    let endIdx = data.activePage * pageSize;

    this.setState({ activePage: data.activePage });
    this.setState({
      devicesList: [...deviceModelList.slice(beginIdx, endIdx)],
    });
  };

  render() {
    const { isLoading, activePage, pageSize, addDeviceModal } = this.state;
    return (
      <div className="deviceModel">
        <LetterLoading isOpen={isLoading} />
        <Sidebar tabActive="iotDevice" categories="deviceModel" />
        <Navigation />
        <div className="deviceModel-content">
          <h2>รุ่นเครื่องจักร</h2>
          <hr />

          <div className="deviceModel-content-search">
            {this.createDeviceSearch()}
          </div>
          <div className="deviceModel-content-table">
            {this.createDataTable()}
          </div>
          <div className="deviceModel-content-pagination">
            <Pagination
              activePage={activePage}
              totalPages={Math.ceil(
                this.context.deviceModelList.length / pageSize
              )}
              onPageChange={this.paginationUpdate}
            />
          </div>
        </div>
        
        {/* Add Device Model Modal */}
        <Modal open={addDeviceModal} onClose={this.toggleAddDeviceModal} centered size="md">
          <Modal.Header>เพิ่มรุ่นเครื่องจักร</Modal.Header>
          <Modal.Content>
            <table style={{ width: '100%' }}>
              <tbody>
                <tr style={{ paddingTop: '2%' }}>
                  <td style={{ width: '35%', textAlign: 'left' }}>รุ่นเครื่องจักร</td>
                  <td style={{ width: '65%' }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="รุ่นเครื่องสีข้าว"
                      onChange={(e) => this.setState({ deviceModel: e.target.value })}
                    />
                  </td>
                </tr>
                {/* <tr style={{ paddingTop: '2%' }}>
                  <td style={{ width: '35%', textAlign: 'left' }}>ยี่ห้อเครื่องมือ</td>
                  <td style={{ width: '65%' }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="ยี่ห้อเครื่องมือ"
                      onChange={(e) => this.setState({ motorBrand: e.target.value })}
                    />
                  </td>
                </tr> */}
                {/* <tr style={{ paddingTop: '2%' }}>
                  <td style={{ width: '35%', textAlign: 'left' }}>รุ่นเครื่องมือ</td>
                  <td style={{ width: '65%' }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="รุ่นเครื่องมือ"
                      onChange={(e) => this.setState({ motorSeries: e.target.value })}
                    />
                  </td>
                </tr> */}
              </tbody>
            </table>
          </Modal.Content>
          <Modal.Actions>
            <Button color="red" onClick={this.toggleAddDeviceModal} inverted>
              <Icon name="remove" /> ยกเลิก
            </Button>
            <Button color="green" onClick={this.addDeviceModel} inverted>
              <Icon name="checkmark" /> เพิ่มอุปกรณ์
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}
DeviceModel.contextType = DeviceContext;

